import { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FetchData, {
  CreateEntry,
  GetList,
  UpdateEntry,
} from "../../providers/dataProvider";
import { CheckNull } from "../../utils/Validate";
import validation from "./validation";

const useForm = (params) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [transportModes, setTransportModes] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [createMsg, setCreateMsg] = useState(null);
  const [show, setShow] = useState(false);
  const [values, setValues] = useState({
    abbreviation: "",
    deliveryDescription: "",
    termsTooltip: "",
    countryRequired: false,
    destinationRequired: false,
    modeofTransports: "",
    createdBy: localStorage.getItem("authidentity"),
    isActive: true,
  });
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: "",
  });
  const [editDeliveryTerms, setEditDeliveryTerms] = useState({
    row: null,
    id: null,
  });
  const navigate = useNavigate();
  const [modes, setModes] = useState([]);
  const [listData, setListData] = useState({});

  const clearError = (fieldName) => {
    setErrors((prev) => {
      if (!prev?.[fieldName]) return prev;
      const next = { ...prev };
      delete next[fieldName];
      return next;
    });
  };

  const { data: transportModeList } = FetchData("deliverymodes");

  useEffect(() => {
    if (transportModeList) setTransportModes(transportModeList);
  }, [transportModeList]);

 

  useEffect(() => {
    if (location?.state) {
      const item = location?.state;
      if (item?.id) {
        if (item?.canEdit !== true) navigate("/dashboard")
             setEditDeliveryTerms({
        id: item?.id,
        row: item?.row,
      });
      }
      else {
        if (item?.canAdd !== true) navigate("/dashboard")
      }
    }
    else if(params == undefined){
      navigate("/dashboard")
    }
  }, [])
  

  const handleFormChange = (e) => {
    const { name, value, checked, type } = e.target;
    setValues({
      ...values,
      [name]: type == "checkbox" ? checked : value,
    });
    clearError(name);
  };

  const handleCheck = (e, value) => {
    let modesCopy = [...modes];
    if (e.target.checked) modesCopy = [...modes, value];
    else modesCopy.splice(modes.indexOf(value), 1);
    setModes(modesCopy);
    setValues({
      ...values,
      modeofTransports: modesCopy.join(","),
    });
    if (modesCopy.length > 0) clearError("transportMode");
  };

 

  useEffect(() => {
    if (!editDeliveryTerms?.id) return;
    if (editDeliveryTerms?.id) {
      const ss = editDeliveryTerms?.row?.modeofTransports
        .split(",")
        .map((ob) => {
          return parseInt(ob);
        });

      setValues({
        abbreviation: editDeliveryTerms?.row?.abbreviation,
        deliveryDescription: editDeliveryTerms?.row?.deliveryDescription,
        termsTooltip: editDeliveryTerms?.row?.termsTooltip,
        countryRequired: editDeliveryTerms?.row?.countryRequired,
        destinationRequired: editDeliveryTerms?.row?.destinationRequired,
        id: editDeliveryTerms?.id,
        modifiedBy: editDeliveryTerms?.row?.modifiedBy,
        isActive: editDeliveryTerms?.row?.isActive,
        modeofTransports: editDeliveryTerms?.row?.modeofTransports,
      });

      setModes(ss);
    }
  }, [editDeliveryTerms]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors(validation(values, modes));
    setIsSubmit(true);
  };

  useEffect(() => {
    const errorCount = Object.values(validation(values, modes)).filter(Boolean).length;
    if (errorCount === 0 && isSubmit) {
      if (CheckNull(values?.id) !== "") {
        setLoading(true);
        UpdateEntry(
          "deliveryterms",
          values,
          setCreateMsg,
          "Delivery terms updated successfully",
          "Failed to update delivery terms"
        );
      } else {
        setLoading(true);
        CreateEntry(
          "deliveryterms",
          values,
          setCreateMsg,
          "Delivery terms added successfully",
          "Failed to create delivery terms"
        );
      }
    } else setIsSubmit(false);
  }, [errors]);

  useEffect(() => {
    if (CheckNull(createMsg?.message).includes('Failed')) {
      let errorsmsg = createMsg.successData;
      setErrorShow({
        show: true,
        errorMessage: errorsmsg,
      });
      setLoading(false);
    } else if (
      createMsg?.message == "Delivery terms added successfully" ||
      createMsg?.message == "Delivery terms updated successfully"
    ) {
      setShow(true);
      setValues({});
    }
  }, [createMsg]);

  const ErrorDoneClick = () => {
    setErrorShow({
      show: false,
      errorMessage: "",
    });
    setCreateMsg(null);
  };

  const SuccessDoneClick = () => {
    setShow(false);
    setLoading(false);
    if (createMsg?.message == "Delivery terms deleted successfully")
      GetList("deliveryterms", "", setListData);
    else navigate("/delivery-terms");
  };

  return {
    values,
    setValues,
    handleFormChange,
    handleSubmit,
    handleCheck,
    show,
    setShow,
    createMsg,
    setCreateMsg,
    errors,
    errorShow,
    setErrorShow,
    ErrorDoneClick,
    SuccessDoneClick,
    transportModes,
    modes,
    listData,
    setListData,
    loading,
    setLoading,
  };
};

export default useForm;
